require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-amazon-vs-etsy-a-comparison-for-merchants.json") })
        }
      }, "path---blog-amazon-vs-etsy-a-comparison-for-merchants");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-amazon-vs-etsy-a-comparison-for-merchants!./.cache/json/blog-amazon-vs-etsy-a-comparison-for-merchants.json
// module id = 425
// module chunks = 231608221292675